import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from '@mui/material';
import { getNestedState } from '../utils/index';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';

const SpermDFIAnalysis = ({keyPath}) => {
  const dispatch = useDispatch();
  const spermDfiAnalysis = useSelector((state) => getNestedState(state.andrologyReducer, keyPath));

  const handleChange = (index, field, value) => {
    const keyPath = `${keyPath}.${index}.${field}`;
    dispatch(setAndrologyData(keyPath, value));
  };

  return (
    <Paper style={{ padding: '16px', marginTop: '16px' }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Description</TableCell>
              <TableCell>Num %</TableCell>
              <TableCell>Comments</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {spermDfiAnalysis.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TextField
                    value={row.description}
                    onChange={(e) => handleChange(index, 'description', e.target.value)}
                    fullWidth
                    disabled // Disable editing for the description field
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={row.percentage}
                    onChange={(e) => handleChange(index, 'percentage', e.target.value)}
                    fullWidth
                    placeholder="Enter percentage"
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={row.comment}
                    onChange={(e) => handleChange(index, 'comment', e.target.value)}
                    fullWidth
                    placeholder="Enter comments"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SpermDFIAnalysis;
